import { render, staticRenderFns } from "./product-slider.vue?vue&type=template&id=5a22f636"
import script from "./product-slider.vue?vue&type=script&lang=js"
export * from "./product-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/tmp/peamit-release.ykZ9nX/Mod.Web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a22f636')) {
      api.createRecord('5a22f636', component.options)
    } else {
      api.reload('5a22f636', component.options)
    }
    module.hot.accept("./product-slider.vue?vue&type=template&id=5a22f636", function () {
      api.rerender('5a22f636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/js/components/product-slider.vue"
export default component.exports